import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Router } from './core/router';
import { useInitLocales } from './locales';
import { Alert } from './components';
import { useInitAnalytics, useSetTokens, useInitReviewPurchaseTracking } from './core/hooks';
import { AppThemeProvider, GlobalStyles } from './core/theme';
import { FallBack, GlobalThemeProvider, Loader } from '@applyft-web/ui-components';
import { useSelector } from 'react-redux';
import { selectLoader } from './core/store/loader';
import { selectShowCookieBanner } from './core/store/app';
import { selectGoogleFlow } from './core/store/plans';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './core/constants';
import { fixEncodedUrl } from '@applyft-web/utils';
import { sendAnalyticsEvents } from './analytics';

fixEncodedUrl(sendAnalyticsEvents);

const App = () => {
  const { ready, isRtl } = useInitLocales();
  const { show, message } = useSelector(selectLoader);
  const showCookieBanner = useSelector(selectShowCookieBanner);
  const googleFlow = useSelector(selectGoogleFlow);

  useSetTokens();
  useInitAnalytics(googleFlow);
  useInitReviewPurchaseTracking();

  if (!ready) return <Loader show={true} />;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GlobalThemeProvider projectTheme={'family-locator'} isRtl={isRtl}>
        <AppThemeProvider>
          <GlobalStyles $showCookieBanner={showCookieBanner} />
          <Suspense fallback={<FallBack />}>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
            <Alert />
            <Loader show={show} message={message} />
          </Suspense>
        </AppThemeProvider>
      </GlobalThemeProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
